export const AppConstants = {
  appName: "Notesmate",
  authTokenKey: "notesmateAuthToken",
  noteTypeKey: "noteType",
  noteFormatKey: "noteFormat",
};
